<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <router-view v-if="isLoaded" />
    <div class="app-loading" v-else>
      <Spin size="large" fix></Spin>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "./utils/mixin";
import { defaultSiteConfig } from "./utils/store";
import { global, account } from "./request";
import { getLoginUser, saveToken } from "./utils/localStorage";
import { isMobile } from "./utils/utils";
export default {
  mixins: [siteMixin],
  data() {
    return {
      isLoaded: false,
    };
  },
  mounted() {
    const token = this.getQueryParam("token");
    //console.log("request token", token);
    if (token) {
      account.getUserInfo(token).then((res) => {
        if (res.status == 1) {
          this.login(res.data);
        }
        this.initLoginUser();
        this.getSiteConfig();
      });
    } else {
      this.initLoginUser();
      this.getSiteConfig();
    }
    //console.log(window.location.pathname);
  },
  methods: {
    // 初始化用户登录信息
    initLoginUser() {
      var userInfo = getLoginUser();
      var cookie = this.$cookies.get("coksinfo");
      if (cookie && userInfo && Object.keys(userInfo).length > 0) {
        const username = this.$base64.decode(cookie);
        if (username == userInfo.userName) {
          this.setUserLogin(userInfo);
          //this.kickOut();
        }
      }
    },
    getQueryParam(variable, url) {
      var query = url || window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    //获取全局基础数据
    getSiteConfig() {
      let domain = document.domain;
      if (process.env.NODE_ENV === "development") {
        // domain = "www.beegoedu.com";//生产
        // domain = "hyt.beegoedu.com"; //生产
        // domain = "zsbpc23.zhewx.com"; //开发环境域名
        // domain = "bg-pc-test.beeeeego.com"; //测试发环境域名
      }
      this.$Loading.start();
      let agencyId = this.getQueryParam("agencyId");
      if (!agencyId) {
        const tempId = sessionStorage.getItem("agencyId");
        if (tempId) {
          agencyId = tempId;
        } else {
          agencyId = 0;
        }
      } else {
        sessionStorage.setItem("agencyId", agencyId);
      }
      if (domain.indexOf("beegoedu.com") < 0) {
        agencyId = 0;
      }
      //console.log("agencyId", agencyId);
      const isApi = process.env.VUE_APP_ROUTE_MODEL == 2 ? 1 : 0;
      //console.log("isApi", process.env.VUE_APP_ROUTE_MODEL);
      global.siteConfig(domain, agencyId, isApi).then((result) => {
        if (result.status == 1) {
          let config = {};
          if (result.data.agencyId === 0) {
            config = Object.assign(defaultSiteConfig, result.data);
          } else {
            config = result.data;
          }

          saveToken({
            preAuth: config.token,
            nextAuth: this.loginUser ? this.loginUser.token : "",
          });

          //console.log(result);
          this.setSiteConfig(config);

          //出现跳转，后面的不再执行
          const jump = this.jumpMobile();
          if (jump) return;

          //调试用，强制到固定模板
          // this.siteConfig.theme="fresh";
          //根据模板写入主题样式名
          document.getElementById("app").className = this.siteConfig.theme;

          console.log("siteConfig.theme", this.siteConfig.theme);

          this.setMetaIcon();
          this.isLoaded = true;
          this.$Loading.finish();
        } else {
          this.$Loading.error();
          this.$Message.error("数据请求异常");
        }
      });
    },
    jumpMobile() {
      const path = window.location.pathname;
      if (path.includes("/app")) return false;
      if (!isMobile()) return false;
      const mobileProtocol = "http://";
      let mobileDomain = "m.beegoedu.com";

      if (this.siteConfig.mdomain) {
        mobileDomain = this.siteConfig.mdomain;
      }

      if (path.indexOf("/topic/major") > -1) {
        const productId = path.split("/")[3];
        window.location.href = `${mobileProtocol}${mobileDomain}/mall/major?productid=${productId}`;
      } else if (path.indexOf("/topic/course") > -1) {
        const productId = path.split("/")[3];
        window.location.href = `${mobileProtocol}${mobileDomain}/mall/major?productid=${productId}`;
      } else if (path.indexOf("/live/scene") > -1) {
        //场次直播
        const params = path.split("?");
        const param = params.length > 1 ? params[1] : "";
        window.location.href = `${mobileProtocol}${mobileDomain}/share/channelList/?${param}`;
      } else if (
        path.indexOf("/live/index") > -1 ||
        path.indexOf("/live/playback") > -1
      ) {
        const liveId = path.split("/")[3];
        window.location.href = `${mobileProtocol}${mobileDomain}/user/viewLiveVideo.do?AgencyId=${this.siteConfig.agencyId}&Id=${liveId}`;
      } else if (path.indexOf("/live/spread") > -1) {
        const liveId = path.split("/")[3];
        const adminId = this.getQueryParam("adminId") || 0;
        window.location.href = `${mobileProtocol}${mobileDomain}/user/viewLiveVideo.do?AgencyId=${this.siteConfig.agencyId}&Id=${liveId}&adminId=${adminId}`;
      } else if (path.indexOf("/login/livespread") > -1) {
        this.adminId = 0;
        const rdtUrl = this.$route.query.redirect;
        if (rdtUrl) {
          let urlArray = rdtUrl.split("?");
          if (urlArray.length > 1) {
            let adminArray = urlArray[1].split("=");
            // if (adminArray.length > 1) this.adminId = Number(adminArray[1]);
            if (adminArray.length > 1)
              this.adminId = this.getQueryParam("adminId", urlArray[1]);
          }
          const tempIdIndex = urlArray[0].lastIndexOf("/");
          this.liveId = Number(urlArray[0].substring(tempIdIndex + 1));
        }
        window.location.href = `${mobileProtocol}${mobileDomain}/user/viewLiveVideo.do?AgencyId=${this.siteConfig.agencyId}&Id=${this.liveId}&adminId=${this.adminId}`;
      } else {
        const jumpUrl = this.siteConfig.mdomain
          ? `${mobileProtocol}${mobileDomain}`
          : `${mobileProtocol}${mobileDomain}`;
        window.location.href = jumpUrl;
      }
      return true;
    },
    setMetaIcon() {
      if (this.siteConfig.titleIcon) {
        const iconUrl =
          process.env.VUE_APP_IMAGE_CDN + this.siteConfig.titleIcon;
        document.querySelector("link[rel=icon]").setAttribute("href", iconUrl);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.app-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
